export default "__VITE_ASSET__Bbs1SjaL__"